import React from 'react'
import { useTranslation } from 'react-i18next';
import { useGetLocationRequestConfigsQuery, useUpdateLocationRequestConfigMutation } from '../../api/locationRequestConfigsApiSlice';
import Tabs from '../../components/Tabs';
import TreeBorderStructure from '../../components/TreeBorderStructure';
import CollapsableLocationRequestConfig from '../../components/sdk/CollapsableLocationRequestConfig';
import { useGetIdfaRequestConfigsQuery, useUpdateIdfaRequestConfigMutation } from '../../api/idfaRequestConfigsApiSlice';
import CollapsableIdfaRequestConfig from '../../components/sdk/CollapsableIdfaRequestConfig';
import {useGetCurrentUserQuery} from "../../api/userApiSlice";
import { Loader, Title } from '../../components/components';

const PublisherLocationRequestConfig = () => {

  const { data: {publisherId} = {}, isCurrentUserSuccess } = useGetCurrentUserQuery()
  const {data : locationRequests = {}, isSuccess, isLoading, refetch} = useGetLocationRequestConfigsQuery(publisherId, { skip: !publisherId })
  const { t } = useTranslation();
  const [updateLocationRequestConfig] = useUpdateLocationRequestConfigMutation()

  return (
    <>
      <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
        <TreeBorderStructure>
          <CollapsableLocationRequestConfig
            title={locationRequests.name}
            icon={"publisher"}
            closeBtnText={t('locationRequestConfig.default_config')}
            onSave={updateLocationRequestConfig}
            data={{...locationRequests, publisher_id: publisherId}}/>
          {
            locationRequests.apps && locationRequests.apps.map((app, i) => {
              return (
                <CollapsableLocationRequestConfig
                  title={app.name}
                  key={i}
                  icon={app.os}
                  closeBtnText={t('locationRequestConfig.config')}
                  onSave={updateLocationRequestConfig}
                  data={{...app, publisher_id: publisherId}}/>
              )
            })
          }
        </TreeBorderStructure>
      </Loader>
    </>
  )
}

const PublisherIdfaRequestConfig = () => {
  const { data: {publisherId} = {}, isCurrentUserSuccess } = useGetCurrentUserQuery()
  const {data : idfaRequests = {}, isSuccess, isLoading, refetch} = useGetIdfaRequestConfigsQuery(publisherId, { skip: !publisherId })
  const { t } = useTranslation();
  const [updateIdfaRequestConfig] = useUpdateIdfaRequestConfigMutation()

  if (! isSuccess) { return (<></>) }

  return (
    <>
      <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
        <TreeBorderStructure>
          <CollapsableIdfaRequestConfig
            title={idfaRequests.name}
            icon={"publishers"}
            closeBtnText={t('idfaRequestConfig.default_config')}
            onSave={updateIdfaRequestConfig}
            data={{...idfaRequests, publisher_id: publisherId}}/>
          {
            idfaRequests.apps && idfaRequests.apps.map((app, i) => {
              return (
                <CollapsableIdfaRequestConfig
                  title={app.name}
                  key={i}
                  icon={app.os}
                  closeBtnText={t('idfaRequestConfig.config')}
                  onSave={updateIdfaRequestConfig}
                  data={{...app, publisher_id: publisherId}}/>
              )
            })
          }
        </TreeBorderStructure>
      </Loader>
    </>
  )
}

const SdkConfiguration = () => {
  const { t } = useTranslation();

  return (
    <>
      <Title main={"SDK"} sub={t("publisher.actions.configuration")}  />
      <Tabs active={"locationRequestConfig"}>
        <PublisherLocationRequestConfig icon={"configure"} as="locationRequestConfig"/>
        <PublisherIdfaRequestConfig icon={"configure"} as="idfaRequestConfig"/>
      </Tabs>
    </>
  );
}

export default SdkConfiguration;
